const data = [
  {
    id: 1,
    visible: false,
    title: "New module A",
    status: false,
    lists: [
      {
        id: 1231,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 1131,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 1331,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 1431,
        title: "How to set up a page",
        status: false,
      },
    ],
  },
  {
    id: 2,
    visible: false,
    title: "New module B",
    status: false,
    lists: [
      {
        id: 1631,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 1731,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 1831,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 1931,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 190031,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 10931,
        title: "How to set up a page",
        status: false,
      },
      ,
      {
        id: 193001,
        title: "How to set up a page",
        status: false
      }
    ],
  },
  {
    id: 4,
    visible: false,
    title: "New module C",
    status: false,
    lists: [
      {
        id: 1637,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 1738,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 1839,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 1930,
        title: "How to set up a page",
        status: false,
      },
      {
        id: 1030,
        title: "How to set up a page",
        status: false,
      },
    ],
  },
];

export default data;
